const tabs = (): void => {
  const classes = {
    tabButtonActive: 'tab--active',
    tabContentActive: 'tabbed-content--active',
  };

  const selectors = {
    tabsSection: '[data-tabs]',
    tabsGroupID: 'data-tabs-group-id',
    tabsButtons: '[data-tab]',
    tabTarget: 'data-tab',
    // Tab
    tabContentID: 'data-tabbed-content',
    tabContentGroup: 'data-tabbed-content-group',
  };

  const tabsSections = document.querySelectorAll(selectors.tabsSection);

  tabsSections.forEach((section) => {
    const tabGroup = section.getAttribute(selectors.tabsGroupID);
    const tabButtons = section.querySelectorAll<HTMLElement>(
      selectors.tabsButtons
    );

    tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', () => {
        const tabTarget = tabButton.getAttribute(selectors.tabTarget);

        if (tabGroup == 'unassigned') {
          const targetContent = document.querySelector(
            `[${selectors.tabContentID}="${tabTarget}"][data-tabbed-content-group="unassigned"]`
          );

          if (targetContent) {
            const otherUnassignedContent = document.querySelectorAll(
              `[data-tabbed-content][data-tabbed-content-group="unassigned"]`
            );
            otherUnassignedContent.forEach((content) => {
              content.classList.remove(classes.tabContentActive);
            });

            const otherUnassignedTabButtons = document.querySelectorAll(
              `[data-tabs][data-tabs-group-id="unassigned"] [data-tab]`
            );
            otherUnassignedTabButtons.forEach((otherTabButton) => {
              otherTabButton.classList.remove(classes.tabButtonActive);
            });

            targetContent.classList.add(classes.tabContentActive);
            tabButton.classList.add(classes.tabButtonActive);
          }
        } else {
          const targetContent = document.querySelector(
            `[${selectors.tabContentID}="${tabTarget}"][data-tabbed-content-group="${tabGroup}"]`
          );

          if (targetContent) {
            const otherGroupContent = document.querySelectorAll(
              `[data-tabbed-content][data-tabbed-content-group="${tabGroup}"]`
            );
            otherGroupContent.forEach((content) => {
              content.classList.remove(classes.tabContentActive);
            });

            const otherGroupTabButtons = document.querySelectorAll(
              `[data-tabs][data-tabs-group-id="${tabGroup}"] [data-tab]`
            );
            otherGroupTabButtons.forEach((otherTabButton) => {
              otherTabButton.classList.remove(classes.tabButtonActive);
            });

            targetContent.classList.add(classes.tabContentActive);
            tabButton.classList.add(classes.tabButtonActive);
          }
        }
      });
    });
  });
};

export default tabs;
